import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CheckCircleIcon from './icons/CircleCheckIcon';
import XIcon from './icons/XIcon';

const CheckedIndicator = ({ checked, title }) => (
  <div className={getCapabilityClassName(checked)} title={title}>
    {checked && <CheckCircleIcon className="w-5 h-5 text-green" />}
    {!checked && <XIcon className="w-4 h-4 text-red-500" />}
  </div>
);

CheckedIndicator.propTypes = {
  checked: PropTypes.bool,
  title: PropTypes.string,
};

CheckedIndicator.defaultProps = {
  checked: false,
  title: '',
};

export default CheckedIndicator;

function getCapabilityClassName(value) {
  return classnames(
    'flex-none',
    'rounded-full',
    'w-10',
    'h-10',
    'flex',
    'justify-center',
    'items-center',
    {
      'bg-green-50': value,
      'bg-red-50': !value,
    },
  );
}
